import Vue from 'vue'
import axios from 'axios'
axios.defaults.baseURL = '/modgen2'

import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import App from './App'

Vue.use(BootstrapVue)
Vue.prototype.$http = axios
Vue.config.productionTip = false

new Vue({
    el: '#app',
    render: h => h(App)
}).$mount('#app')
